import { Paper } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import { makeStyles } from "@material-ui/core/styles";
import EventNoteIcon from "@material-ui/icons/EventNote";
import Pagination from "material-ui-flat-pagination";
import React, { useState } from "react";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "auto",
    width: "100%",
    maxWidth: 300,
    padding: theme.spacing(1)
  },
  pagination: {
    textAlign: "center"
  }
}));

const numPerPage = 6;

export default function NestedList() {
  const classes = useStyles();
  const [offset, setOffset] = useState<number>(0);

  return (
    <Paper className={classes.root} elevation={4}>
      <List
        component="nav"
        dense
        subheader={
          <ListSubheader component="div" disableSticky>
            通知
          </ListSubheader>
        }
      >
        {[1, 2, 3, 4, 5, 6].map(item => (
          <ListItem button key={item + offset}>
            <ListItemIcon>
              <EventNoteIcon />
            </ListItemIcon>
            <ListItemText
              primary={`通知 ${item + offset}`}
              primaryTypographyProps={{ color: "textPrimary" }}
            />
          </ListItem>
        ))}
      </List>
      <div className={classes.pagination}>
        <Pagination
          reduced
          limit={numPerPage}
          offset={offset}
          total={60}
          onClick={(e, newOffset): void => setOffset(newOffset)}
        />
      </div>
    </Paper>
  );
}
